"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartButton = exports.CartText = exports.CartIcon = exports.CartContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const svg_components_1 = require("../../../../assets/svg-components");
const Typography_1 = __importDefault(require("../../../UI/Typography"));
exports.CartContainer = styled_components_1.default.button `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 0;
  margin-left: ${props => props.theme.spacing.m1}px;
  padding: ${props => props.theme.spacing.s2}px;
  background-color: ${props => props.theme.palette.ORANGE_100};
  border-radius: ${props => props.theme.attributes.borderRadius.sm}px;
`;
exports.CartIcon = (0, styled_components_1.default)(svg_components_1.CartIcon) `
  > path {
    transition: ${props => props.theme.attributes.transition.fast};
    stroke: ${props => (props.$isTransparent ? props.theme.palette.BW_100 : props.theme.palette.LIGHT_BLACK)};
  }
`;
exports.CartText = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.BW_100};
  margin-left: ${props => props.theme.spacing.s2}px;
`;
exports.CartButton = styled_components_1.default.button `
  margin-left: ${props => (props.$hasCartItems ? 0 : props.theme.spacing.m1)}px;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;
exports.default = {
    CartContainer: exports.CartContainer,
    CartIcon: exports.CartIcon,
    CartText: exports.CartText,
    CartButton: exports.CartButton
};
